export const CommissioningPowerDeviceTypeConstant: any[] = [
  {
    value: 'ChargingDeviceKvA',
    displayName: 'Ladeeinrichtung (ab 3,6kVA)'
  },
  {
    value: 'ChargingDeviceKW',
    displayName: 'Ladeeinrichtung (ab 12kW)'
  },
  {
    value: 'InstantWaterHeater',
    displayName: 'Durchlauferhitzer (ab 18kW)'
  },
  {
    value: 'GenerationPlan',
    displayName: 'Erzeugungsanlage'
  },
  {
    value: 'ElectricHeating',
    displayName: 'E-Heizung / Wärmepumpe / Raumkühlanlage'
  }
];

export const CommissioningGasDeviceTypeConstant = [
  {
    value: 'Boiler',
    displayName: 'Heizkessel'
  },
  {
    value: 'Stove',
    displayName: 'Herd'
  },
  {
    value: 'DarkHeating',
    displayName: 'Dunkelstrahler'
  },
  {
    value: 'CondensingBoiler',
    displayName: 'Brennwertgerät'
  },
  {
    value: 'GasInstantHeater',
    displayName: 'Gas-Durchlauferhitzer'
  },
  {
    value: 'GasHeaterUnit',
    displayName: 'Gas-Heizautomat'
  },
  {
    value: 'Others',
    displayName: 'Sonstiges'
  }
];

export type CommissioningGasDeviceType = 'Boiler' | 'Stove' | 'DarkHeating' | 'Others';

export enum DeviceTypeName {
  Eintarif = 'Eintarif',
  Zweitarif = 'Zweitarif',
  Zweirichtung = 'Zweirichtung',
  Erzeuger = 'Erzeuger',
  ZweirichtungZweitarif = 'Zweirichtung-Zweitarif'
}

export enum MobileConnectionStrengthEnum {
  NO = 'NO',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  GOOD = 'GOOD'
}
export const MobileConnectionStrengthDisplayNames = {
  [MobileConnectionStrengthEnum.NO]: 'Kein Empfang',
  [MobileConnectionStrengthEnum.LOW]: 'Schwach',
  [MobileConnectionStrengthEnum.MEDIUM]: 'Mittel',
  [MobileConnectionStrengthEnum.GOOD]: 'Voller Empfang'
};

export const CommissioningPowerLocationTypeConstant: any[] = [
  {
    value: 'Public',
    displayName: 'Öffentlich'
  },
  {
    value: 'Private',
    displayName: 'Privat'
  }
  // {
  //   value: 'SemiPublic',
  //   displayName: 'Halböffentlich'
  // }
];

export const CommissioningPowerPumpTypeTypeConstant: any[] = [
  {
    value: 'AirWater',
    displayName: 'Luft/Wasser WP'
  },
  {
    value: 'SoleWater',
    displayName: 'Sole/Wasser WP'
  },
  {
    value: 'WaterWater',
    displayName: 'Wasser/Wasser WP'
  },
  {
    value: 'Other',
    displayName: 'Sonstige'
  }
];
export const CommissioningPowerOperationalModeTypeConstant: any[] = [
  {
    value: 'Monovalent',
    displayName: 'Monovalent'
  },
  {
    value: 'BivalentAlternative',
    displayName: 'Bivalent/Alternativ'
  },
  {
    value: 'BivalentParallel',
    displayName: 'Bivalent/Parallel'
  },
  {
    value: 'Monoenergetic',
    displayName: 'Monoenergetisch'
  }
];

export const CommissioningPowerHeatSourceTypeConstant: any[] = [
  {
    value: 'OutOfAir',
    displayName: 'Außenluft'
  },
  {
    value: 'RunningWater',
    displayName: 'Laufwasser'
  },
  {
    value: 'ProcessHeat',
    displayName: 'Porzeßwärme'
  },
  {
    value: 'HeatRecovery',
    displayName: 'Wärmerückgewinnug'
  },
  {
    value: 'GroundWater',
    displayName: 'Grundwasser'
  },
  {
    value: 'Ground',
    displayName: 'Erdreich'
  },
  {
    value: 'SolarAbsorber',
    displayName: 'Solarabsorber'
  },
  {
    value: 'Other',
    displayName: 'Sonstige'
  }
];

export const CommissioningPowerObjectTypeTypeConstant: any[] = [
  {
    value: 'SingleHouse',
    displayName: 'Einfamilienhaus'
  },
  {
    value: 'MultiHouse',
    displayName: 'Mehrfamilienhaus'
  },
  {
    value: 'NonResidential',
    displayName: 'Nichtwohngebäude / Gewerbe'
  }
];

export const CommissioningPowerHeatingUseConstant: any[] = [
  {
    value: 'DirectHeating',
    displayName: 'Direktheizung'
  },
  {
    value: 'StorageHeating',
    displayName: 'Speicherheizung'
  }
];
